// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgc_a bha_vf bha_a bha_q bha_k","AdSlotMail__mail--notLoaded":"bgc_b bha_eu bha_bj bha_vu","show-ad-not-loaded":"bgc_c","AdSlotMail__cta":"bgc_e"};